/*Docs: https://github.com/kiprotect/klaro/blob/master/dist/config.js*/
window.klaroConfig = {
  // You can customize the ID of the DIV element that Klaro will create
  // when starting up. If undefined, Klaro will use 'klaro'.
  elementID: 'klaro',
  // Setting this to true will keep Klaro from automatically loading itself
  // when the page is being loaded.
  noAutoLoad: true,
  privacyPolicy: 'https://o-mask.de/res/rechtstexte/Datenschutzerklaerung.pdf',
  // This is a list of third-party services that Klaro will manage for you.
  // Defines the default state for services (true=enabled by default).
  default: true,
  // You can group services by their purpose in the modal. This is advisable
  // if you have a large number of services. Users can then enable or disable
  // entire groups of services instead of having to enable or disable every service.
  groupByPurpose: false,
  services: [

    {
      // Each service should have a unique (and short) name.
      name: 'shopify',

      // If "default" is set to true, the service will be enabled by default
      // Overwrites global "default" setting.
      // We recommend leaving this to "false" for services that collect
      // personal information.
      default: true,

      // The title of you service as listed in the consent modal.
      title: 'Shopify - Warenkorb',

      // The purpose(s) of this service. Will be listed on the consent notice.
      // Do not forget to add translations for all purposes you list here.
      purposes: ['shop'],
      // An optional callback function that will be called each time
      // the consent state for the service changes (true=consented). Passes
      // the `service` config as the second parameter as well.
      callback: function(consent, service) {
        // This is an example callback function.
        // console.log('User consent for service ' + service.name + ': consent=' + consent);
        // To be used in conjunction with Matomo 'requireCookieConsent' Feature, Matomo 3.14.0 or newer
        // For further Information see https://matomo.org/faq/new-to-piwik/how-can-i-still-track-a-visitor-without-cookies-even-if-they-decline-the-cookie-consent/

        if(consent==true){

            if(!window.shopifyIsLoaded){
              initShopify();
            }
            setVisibilityActivateShopifyButton(false);

        } else {
          if(!window.shopifyIsLoaded) {
            setVisibilityActivateShopifyButton(true);
          }
        }

      },

      // If "required" is set to true, Klaro will not allow this service to
      // be disabled by the user.
      required: false,

      // If "optOut" is set to true, Klaro will load this service even before
      // the user gave explicit consent.
      // We recommend always leaving this "false".
      optOut: true,

      // If "onlyOnce" is set to true, the service will only be executed
      // once regardless how often the user toggles it on and off.
      onlyOnce: true,
    },
    {
      // Each service should have a unique (and short) name.
      name: 'matomo',

      // If "default" is set to true, the service will be enabled by default
      // Overwrites global "default" setting.
      // We recommend leaving this to "false" for services that collect
      // personal information.
      default: true,

      // The title of you service as listed in the consent modal.
      title: 'Matomo/Piwik',

      // The purpose(s) of this service. Will be listed on the consent notice.
      // Do not forget to add translations for all purposes you list here.
      purposes: ['analytics'],

      // A list of regex expressions or strings giving the names of
      // cookies set by this service. If the user withdraws consent for a
      // given service, Klaro will then automatically delete all matching
      // cookies.
      cookies: [
        // you can also explicitly provide a path and a domain for
        // a given cookie. This is necessary if you have services that
        // set cookies for a path that is not "/" or a domain that
        // is not the current domain. If you do not set these values
        // properly, the cookie can't be deleted by Klaro
        // (there is no way to access the path or domain of a cookie in JS)
        // Notice that it is not possible to delete cookies that were set
        // on a third-party domain! See the note at mdn:
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#new-cookie_domain
        [/^_pk_.*$/, '/', 'analytics.o-mask.de'], //for the production version
        [/^_pk_.*$/, '/', 'analytics.o-mask.de'], //for the local version
        'piwik_ignore',
      ],

      // An optional callback function that will be called each time
      // the consent state for the service changes (true=consented). Passes
      // the `service` config as the second parameter as well.
      callback: function(consent, service) {
        // This is an example callback function.
        // console.log('User consent for service ' + service.name + ': consent=' + consent);
        // To be used in conjunction with Matomo 'requireCookieConsent' Feature, Matomo 3.14.0 or newer
        // For further Information see https://matomo.org/faq/new-to-piwik/how-can-i-still-track-a-visitor-without-cookies-even-if-they-decline-the-cookie-consent/

        if(consent==true){
            //initMatomo();

            _paq.push(['rememberCookieConsentGiven']);


        } else {
            //initMatomo();

            _paq.push(['forgetCookieConsentGiven']);


        }

      },

      // If "required" is set to true, Klaro will not allow this service to
      // be disabled by the user.
      required: false,

      // If "optOut" is set to true, Klaro will load this service even before
      // the user gave explicit consent.
      // We recommend always leaving this "false".
      optOut: false,

      // If "onlyOnce" is set to true, the service will only be executed
      // once regardless how often the user toggles it on and off.
      onlyOnce: true,
    },
  ],
// Example that shows how to overwrite specific translations:
translations: {
  // Erasing keys from these translations will make Klaro use the default,
  // bundled translations. The top-level key is the language code:
  de: {
    consentModal: {
      description:
        'Hier können Sie einsehen und anpassen, welche Information wir über Sie ' +
        'sammeln. Einträge die mit einem * gekennzeichnet sind dienen lediglich ' +
        'zu Demonstrationszwecken und werden nicht wirklich verwendet. '           },
    inlineTracker: {
      description: 'Beispiel für ein Inline-Tracking Skript',
    },
    externalTracker: {
      description: 'Beispiel für ein externes Tracking Skript',
    },
    // You should provide a title and a description for every app
    // that you define in the 'apps' section.
    adsense: {
      description: 'Anzeigen von Werbeanzeigen (Beispiel)',
        title: 'Google AdSense*',
    },
    matomo: {
      description: 'Sammeln von Besucherstatistiken',
    },
    googleFonts: {
      description: 'Web-Schriftarten von Google gehostet',
    },
    // You should also define translations for every purpose you define
    // in the 'apps' section.
    purposes: {
      analytics: 'Besucher-Statistiken',
      shop: 'Online Shopping / Warenkorb',
    },
  }}
}
